import AppRequests from './requests';

import { SOCKET_INIT } from 'root/.env';

const RECONNECT_MAX_COUNT = 10;
const RECONNECT_DELAY = 1000 * 4;

let reconnectCount = 0;

export default {
  message: '',
  vm: undefined,
  socket: undefined,

  open(url, vm) {
    console.log('open', url);
    this.createWebSocket(url);

    this.socket.onopen = e => this.onOpen(e);
    this.socket.onclose = e => this.onClose(e);
    this.socket.onmessage = e => this.onMessage(e);
    this.socket.onerror = e => this.onError(e);
    this.vm = vm;
  },

  close(code = 1000, reason = 'default reason') {
    this.socket.close(code, reason);
    this.socket = undefined;
  },

  createWebSocket(socketUrl) {
    if (this.socket) {
      this.socket.close();
    }

    if (!socketUrl) {
      socketUrl = SOCKET_INIT;
    }

    console.log('socketUrl', socketUrl, localStorage.getItem('token'));

    this.socket = new WebSocket(`${socketUrl}${localStorage.getItem('token')}`);
  },

  send(text) {
    this.socket.send(text);
  },

  reconnect() {
    if (reconnectCount >= RECONNECT_MAX_COUNT) {
      return reconnectCount = 0;
    }

    reconnectCount++;
    setTimeout(this.open.bind(this), RECONNECT_DELAY);
  },

  onOpen(e) {
    // eslint-disable-next-line no-console
    console.log('Соединение открыто', e);
  },

  onClose(e) {
    if (e.wasClean) {
      // eslint-disable-next-line no-console
      console.log('Соединение закрыто чисто', e);
      return;
    }

    // eslint-disable-next-line no-console
    console.log(`Соединение прервано, ${e.code}, ${e.reason}`);

    this.reconnect();
  },

  onMessage(e) {
    // eslint-disable-next-line no-console
    console.log('onMessage', e);

    this.message = e;
    AppRequests.mainProcess(e);
  },

  onError(e) {
    console.error(`[error] ${e.message}`);
  },
};
